import { on } from '@ember/modifier';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/common/upgrade-plan-base';
import CommonUpgradePlanBaseComponent from 'webapp/components/common/upgrade-plan-base';

export default abstract class CommonUpgradePlanLinkComponent<
	T extends Args,
> extends CommonUpgradePlanBaseComponent<T> {
	get iconName() {
		return this.args.icon || undefined;
	}

	get iconSize(): IconSize {
		return this.args.iconSize || 'md';
	}
	<template>
		<a role="button" class="upgrade-plan-link" {{on "click" this.handleLimitations}}>
			{{#if this.iconName}}
				<CommonUiIconComponent @name={{this.iconName}} @size={{this.iconSize}} />
			{{/if}}{{this.text}}
		</a>
	</template>
}
